import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TestArticle } from './test-article';
export { TestArticle };
import { testArticleSchema } from '@schemas/business-objects/test-article';
import { PdfDocumentFormGroup } from './pdf-document-form-group';
import { TestResultFormArray } from './test-result-form-group';

export class TestArticleFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    type: SchemaFormControl;
    oralReadingFluency: SchemaFormControl;
    description: SchemaFormControl;
    pdfDocument: PdfDocumentFormGroup;
    workingTestResults: TestResultFormArray;
    achievedTestResults: TestResultFormArray;
  };

  declare value: Partial<TestArticle>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(testArticleSchema, TestArticle, data, options);
  }

  get object(): TestArticle {
    return new TestArticle(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'pdfDocument':
        return new PdfDocumentFormGroup();
      case 'workingTestResults':
        return new TestResultFormArray();
      case 'achievedTestResults':
        return new TestResultFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<TestArticle[]> {
    return TestArticle.find(filter);
  }

  static async findOne(filter?: any): Promise<TestArticle | null> {
    return TestArticle.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<TestArticle> {
    return TestArticle.findById(id, filter);
  }

  static async create(data: Partial<TestArticle>): Promise<TestArticle> {
    return TestArticle.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<TestArticle>,
  ): Promise<TestArticle> {
    return TestArticle.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return TestArticle.deleteById(id);
  }
}

export class TestArticleFormArray extends PersistedFormArray {
  readonly entityName = 'TestArticle' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(testArticleSchema, TestArticle, options);
  }

  protected override createItemGroup() {
    return new TestArticleFormGroup();
  }

  get array(): TestArticle[] {
    return this.controls.map((group: TestArticleFormGroup) => group.object);
  }
}

export class TestArticlePersistedArray extends PersistedArray<TestArticle> {
  readonly entityName = 'TestArticle' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TestArticle, options);
  }
}
